"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCALE_LAUNCH_MAX_ADS = void 0;
exports.kpiEventTypePlatform = kpiEventTypePlatform;
exports.isKpiEventForPlatform = isKpiEventForPlatform;
/**
 * Most tested ads one manual scale launch takes. A Meta ad set holds at most
 * 50 ads and a TikTok target fewer, so a larger request could never fit one
 * target. The launch procedures' input enforces it; the launch screens check
 * it first so the user gets a plain message instead of a validation error.
 */
exports.SCALE_LAUNCH_MAX_ADS = 50;
/**
 * The KPI event types each platform's reporting reads, as a KPI event's
 * `type` names them. Scale monitoring asks the campaign's own platform for
 * its KPI event, so an event from another platform fails that request on
 * every run (a Meta `omni_purchase` on a TikTok campaign). TikTok's list
 * includes the TikTok event picker's categories, which TikTok presets store
 * as the type.
 */
const KPI_EVENT_TYPES = {
    META: [
        "META_DEFAULT",
        "META_ACTION",
        "META_COST_PER_ACTION",
        "META_CONVERSION",
        "META_COST_PER_CONVERSION",
        "META_CUSTOM",
    ],
    TIKTOK: ["TIKTOK_DEFAULT", "TIKTOK_CUSTOM", "standard", "app", "custom"],
    GOOGLE: ["GOOGLE_DEFAULT", "GOOGLE_CONVERSION_ACTION"],
    SNAPCHAT: ["SNAPCHAT_PIXEL", "SNAPCHAT_APP"],
};
const KPI_EVENT_PLATFORMS = Object.keys(KPI_EVENT_TYPES);
/** The platform whose reporting reads a KPI event of this type, or null when none does. */
function kpiEventTypePlatform(type) {
    var _a;
    return ((_a = KPI_EVENT_PLATFORMS.find((platform) => KPI_EVENT_TYPES[platform].includes(type))) !== null && _a !== void 0 ? _a : null);
}
/** Whether a scale campaign on `platform` can monitor a KPI event of this type. */
function isKpiEventForPlatform(platform, type) {
    return kpiEventTypePlatform(type) === platform;
}
